import React from 'react'
import { Logo } from '.'
import { useMediaQuery } from '@uidotdev/usehooks'

const Hero = () => {
  const isExtraSmallDevice = useMediaQuery('only screen and (max-width : 640px)')
  const isExtraSmallLandscapeDevice = useMediaQuery(
    'only screen and (orientation: landscape) and (max-width : 640px)'
  )
  const isSmallDevice = useMediaQuery('only screen and (min-width: 640px)')

  let size = ''
  const debugClass = ''

  switch (true) {
    case isExtraSmallLandscapeDevice:
      size = 'sm'
      break
    case isExtraSmallDevice:
    case isSmallDevice:
      size = 'lg'
      break
    default:
      size = 'lg'
  }

  return (
    <div className='grid align-bottom items-center content-center gap-0 landscape:xs:items-center landscape:xs:grid-cols-2 landscape:md:grid-cols-1'>
      <Logo className={'grid' + debugClass} size={size} />
      <h1 className='text-5xl xs:mt-0 md:ml-0 md:mb-2 md:mt-5 text-center font-logo front-normal not-italic landscape:xs:max-md:ml-[-25px]'>
        WITTS
      </h1>
    </div>
  )
}

export { Hero }
